import React from 'react';
export const OrnamentalDivider = ({
  className = ''
}: {
  className?: string;
}) => <div className={`flex items-center justify-center w-full py-6 ${className}`} data-id="element-264">
    <div className="h-[1px] w-1/3 bg-gradient-to-r from-transparent via-gold-dark to-transparent opacity-50" data-id="element-265"></div>
    <div className="mx-4 text-gold-dark opacity-80" data-id="element-266">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-267">
        <path d="M12 2L14.5 9.5L22 12L14.5 14.5L12 22L9.5 14.5L2 12L9.5 9.5L12 2Z" fill="currentColor" data-id="element-268" />
      </svg>
    </div>
    <div className="h-[1px] w-1/3 bg-gradient-to-l from-transparent via-gold-dark to-transparent opacity-50" data-id="element-269"></div>
  </div>;
export const CornerBrackets = ({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) => <div className={`relative p-6 ${className}`} data-id="element-270">
    {/* Top Left */}
    <div className="absolute top-0 left-0 w-6 h-6 border-t-2 border-l-2 border-gold-dark opacity-60" data-id="element-271"></div>
    {/* Top Right */}
    <div className="absolute top-0 right-0 w-6 h-6 border-t-2 border-r-2 border-gold-dark opacity-60" data-id="element-272"></div>
    {/* Bottom Left */}
    <div className="absolute bottom-0 left-0 w-6 h-6 border-b-2 border-l-2 border-gold-dark opacity-60" data-id="element-273"></div>
    {/* Bottom Right */}
    <div className="absolute bottom-0 right-0 w-6 h-6 border-b-2 border-r-2 border-gold-dark opacity-60" data-id="element-274"></div>

    {children}
  </div>;